module.exports = __webpack_public_path__ + "img/headerTitle@2x.1dd264f5.png";